import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import {
  openFormModal,
  setSearch,
} from "../../../store/frasesSeleccionAplicacion/frases-seleccion-aplicacion-plantel/frasesSeleccionAplicacionPlantel.reducer";
import SearchInput from "../../UI/SearchInput";

const FrasesSeleccionAplicacionHeaderPlantel = () => {
  const dispatch = useDispatch();
  const { search } = useSelector(
    (state) => state.frasesSeleccionAplicacionPlantel,
  );

  return (
    <div className="mb-3">
      <div className="row g-2 align-items-center">
        <div className="col-12 col-md-auto">
          <h5 className="mb-0 fw-semibold text-center text-md-start">
            Frases de opción
          </h5>
        </div>

        <div className="col-12 col-md">
          <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end align-items-sm-center">
            <SearchInput
              value={search}
              onChange={(value) => dispatch(setSearch(value))}
              placeholder="Buscar frases..."
              minChars={3}
              className="flex-grow-1"
            />
            {search && (
              <button
                onClick={() => dispatch(setSearch(""))}
                className="btn btn-outline-secondary d-flex align-items-center gap-1"
                style={{ height: "44px" }}
                title="Limpiar búsqueda"
              >
                <Icon icon="mdi:filter-remove-outline" width="18" />
                <span className="d-none d-sm-inline">Limpiar</span>
              </button>
            )}
            <button
              onClick={() => dispatch(openFormModal({ mode: "create" }))}
              className="btn btn-primary d-flex align-items-center gap-1"
              style={{ height: "44px" }}
              title="Nueva frase"
            >
              <Icon icon="mdi:plus" width="18" />
              <span className="d-none d-sm-inline">Nueva frase</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrasesSeleccionAplicacionHeaderPlantel;
